import CustomConfirmationDialog from 'components/CustomConfirmationDialog/CustomConfirmationDialog';
import { DescriptionS } from 'components/Typography/Typography';
import React from 'react';
import { useSelector } from 'react-redux';
import { getErrorSuccessLoaderLabels } from 'redux/modules/dynamicLabels/selectors';

type ErrorStatusDialogProps = {
	onClose: () => void;
	errorMessage?: string;
};

const ErrorStatusDialog = ({ onClose, errorMessage }: ErrorStatusDialogProps) => {
	const statusLabels = useSelector(getErrorSuccessLoaderLabels);
	return (
		<CustomConfirmationDialog
			isNewDashBoardEnabled
			isOpen
			header={<>{statusLabels?.errorMessages?.title}</>}
			hideDialog={onClose}
			width={500}
			padding="0px 16px 24px"
			isError
		>
			<DescriptionS>{errorMessage || statusLabels?.errorMessages?.subtitle}</DescriptionS>
		</CustomConfirmationDialog>
	);
};

export default ErrorStatusDialog;
